import { AccountRoomTag } from '@closer/watermelondb'

export function getLabelName(tag: AccountRoomTag) {
    return (tag.type === 'team' ? '👥 ' : '') + tag.name
}
